import * as React from 'react'
import { useMemo } from 'react'
import { CardFooterCollapse } from '@sales-center/components'
import { SoldServiceStatus } from '../SoldServicesStatus'
import { soldServiceBackgroundColor } from '../utils/soldServiceBackgroundColor'
import { SoldServicesDetails } from '../SoldServicesDetails/SoldServicesDetails'
import { soldServiceStatusColor } from './soldServiceStatusColor'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'

import { darken, useTheme } from '@mui/material/styles'

interface Props {
  opportunityId: number
  onReOpenClick: () => void
  soldServiceStatus: SOLD_SERVICE_STATUS
}

export function SoldServicesCardFooter(props: Props) {
  const { soldServiceStatus: status } = props

  const theme = useTheme()
  const [bgColor, textColor] = useMemo(
    () =>
      [
        soldServiceBackgroundColor(status),
        darken(soldServiceStatusColor(status, theme), 0.6),
      ] as const,
    [status, theme],
  )
  return (
    <CardFooterCollapse
      backgroundColorClosed={bgColor}
      backgroundColorOpen={theme.palette.common.white}
      dataTestId={`soldServicesCardFooterToggle-${props.opportunityId}`}
      headContents={<SoldServiceStatus textColor={textColor} {...props} />}
    >
      <SoldServicesDetails {...props} />
    </CardFooterCollapse>
  )
}
